var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEyeOpened(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00002 6.49999C7.17159 6.49999 6.50002 7.17156 6.50002 7.99999C6.50002 8.82842 7.17159 9.49999 8.00002 9.49999C8.82845 9.49999 9.50002 8.82842 9.50002 7.99999C9.50002 7.17156 8.82845 6.49999 8.00002 6.49999Z",
    fill: "#0E46C0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00002 3.66666C6.25484 3.66666 4.68536 4.36758 3.55443 5.23556C2.98823 5.67011 2.52364 6.15274 2.19768 6.62244C1.87793 7.08319 1.66669 7.56768 1.66669 7.99999C1.66669 8.4323 1.87793 8.91678 2.19768 9.37753C2.52364 9.84723 2.98823 10.3299 3.55443 10.7644C4.68536 11.6324 6.25484 12.3333 8.00002 12.3333C9.7452 12.3333 11.3147 11.6324 12.4456 10.7644C13.0118 10.3299 13.4764 9.84723 13.8024 9.37753C14.1221 8.91678 14.3334 8.4323 14.3334 7.99999C14.3334 7.56768 14.1221 7.08319 13.8024 6.62244C13.4764 6.15274 13.0118 5.67011 12.4456 5.23556C11.3147 4.36758 9.7452 3.66666 8.00002 3.66666ZM5.50002 7.99999C5.50002 6.61928 6.61931 5.49999 8.00002 5.49999C9.38073 5.49999 10.5 6.61928 10.5 7.99999C10.5 9.3807 9.38073 10.5 8.00002 10.5C6.61931 10.5 5.50002 9.3807 5.50002 7.99999Z",
    fill: "#0E46C0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeOpened);
export default __webpack_public_path__ + "static/media/eye-opened.062a5be4513a9a6aabf2ba678dd97a23.svg";
export { ForwardRef as ReactComponent };